import { QueryFunction, QueryKey, useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

export const useDiagnosticsQuery = <TData>({
  queryFn,
  queryKey,
  refetchInterval,
}: {
  queryFn?: QueryFunction<TData, QueryKey> | undefined
  queryKey: QueryKey
  refetchInterval?: number
}) => {
  const queryClient = useQueryClient()
  const queryKeyRef = useRef(queryKey)
  queryKeyRef.current = queryKey

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: queryKeyRef.current, exact: true })
    },
    [queryClient]
  )

  return useQuery({
    queryFn,
    queryKey,
    retry: 1,
    gcTime: 0,
    refetchOnWindowFocus: false,
    refetchInterval,
  })
}
